import { BEBase } from '../constants/app.constant';
import CryptoJS from 'crypto-js';
import { efefrg4rrrg323ffgfssw3e3ddadfw23 } from '../components/componentConst';


const SECRET_KEY = efefrg4rrrg323ffgfssw3e3ddadfw23; // Replace with a secure key

const decryptData = (encryptedData) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedString); // Parse the JSON string
  } catch (error) {
    console.error('Decryption error:', error);
    return null; // Return null if decryption fails
  }
};

export const LoginApi = async (request) => {
  const url = BEBase + 'login/';

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request)
  });

  const data = await response.json();

  if (!response.ok) {
    throw data; // throw actual backend error response
  }

  return data;
};


export const FetchUsernamesApi = async (request) => {
  const url = BEBase + 'fetch_usernames/';

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request)
  });

  const data = await response.json();

  if (!response.ok) {
    throw data;
  }

  return data;
};

export const ForgetPassscodeApi = async (request) => {
  const url = BEBase + 'forget_password/';

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request)
  });

  const data = await response.json();

  if (!response.ok) {
    throw data;
  }

  return data;
};


export const VerifyOtpApi = request => {
  const url = BEBase + 'verify_otp/'

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Invalid Login Credentials')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('Invalid Login Credentials', error)
      throw error // Rethrow the error for further handling
    })
}

export const RegisterApi = request => {
  const url = BEBase + 'signup/'

  return fetch(url, {
    method: 'POST',
    body: request
  })
    .then(async response => {
      const data = await response.json()

      if (!response.ok) {
        // Throw the API's error message from JSON
        throw new Error(JSON.stringify(data))
      }

      return data // If successful, return parsed data
    })
    .catch(error => {
      console.error('Fetch error:', error)
      throw error // Allow caller to handle it
    })
}

export const UpdateUserApi = (request, id) => {
  const url = BEBase + `update_user/${id}/`

  return fetch(url, {
    method: 'PUT',
    body: request
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json()
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error
    })
}

export const GetUserApi = id => {
  const url = `${BEBase}get_user/${id}/`

  return fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json()
    })
    .catch(error => {
      console.log(error, 'error')
      console.error('There was a problem with the fetch operation:', error)
      throw error
    })
}

export const ListUsersApi = request => {
  const url = BEBase + 'list_users/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const fetch_marketaux_news = (request = {}) => {
  const url = BEBase + 'fetch_marketaux_news/'

  // Default pagination parameters
  const payload = {
    page: request.page || 1,
    page_size: request.page_size || 10,
    ...request
  }

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response with pagination metadata
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

const getAuthToken = () => {
  const encryptedCreds = localStorage.getItem('loginCred')
  if (!encryptedCreds) throw new Error('No login credentials found')

  const decryptedCreds = decryptData(encryptedCreds)
  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Invalid login credentials')
  }

  return decryptedCreds.token
}

export const fetch_wallet_detail = () => {
  const url = BEBase + 'wallet/'

  const token = getAuthToken()

  return fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + token,
    },
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to fetch wallet')
      }
      return response.json()
    })
}

export const create_wallet_order = (request = {}) => {
  const url = BEBase + 'wallet/create-order/'

  const token = getAuthToken()

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + token,
    },
    body: JSON.stringify({
      amount: request.amount,
    }),
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to create Razorpay order')
      }
      return response.json()
    })
}

export const verify_wallet_payment = (request = {}) => {
  const url = BEBase + 'wallet/verify-payment/'

  const token = getAuthToken()

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + token,
    },
    body: JSON.stringify({
      razorpay_order_id: request.razorpay_order_id,
      razorpay_payment_id: request.razorpay_payment_id,
      razorpay_signature: request.razorpay_signature,
    }),
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Payment verification failed')
      }
      return response.json()
    })
}


export const ListClientsApi = request => {
  const url = BEBase + 'list_client/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: request
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const CreateTaskApi = request => {
  const url = BEBase + 'create_paid_task/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify({
      username: request.username,
      amount: request.amount,
      taskHeading: request.taskHeading,
      taskDescription: request.taskDescription,
      paymentLink: request.paymentLink
    })
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const ListTaskApi = request => {
  const url = BEBase + 'list_user_task/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const CreateCourseApi = formData => {
  const url = BEBase + 'create_product/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token,
      'Content-Type': 'application/json'
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('Section Not Added or Some Other error', error)
      throw error // Rethrow the error for further handling
    })
}

export const ListProductApi = () => {
  const url = BEBase + 'list_product/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify({ id: JSON.parse(authToken).user.id })
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const UpdateCourseApi = formData => {
  const url = BEBase + 'update_product/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token,
      'Content-Type': 'application/json'
      // Removed Content-Type; let the browser handle it automatically
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          console.log('Error details:', err)
          throw new Error('Network response was not ok')
        })
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const DeleteCourseApi = formData => {
  const url = BEBase + 'delete_product/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      window.location.reload()
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const DeleteSectionApi = formData => {
  const url = BEBase + 'delete_section/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      window.location.reload()
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const UpdateCourseImageApi = formData => {
  const url = BEBase + 'update_product_image/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
      // Removed Content-Type; let the browser handle it automatically
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          console.log('Error details:', err)
          throw new Error('Network response was not ok')
        })
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const CreateSubjectApi = async (formData) => {
  const url = BEBase + 'create_subject/';
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData);

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData
  });

  let result;
  try {
    result = await response.json();
  } catch (jsonError) {
    throw new Error('Server did not return JSON');
  }

  if (!response.ok) {
    // Throw error with the backend message
    const errMsg = result?.error || result?.message || JSON.stringify(result);
    const error = new Error(errMsg);
    error.response = { data: result };
    throw error;
  }

  return result;
};


export const ListSubjectApi = (request) => {
  const url = BEBase + 'list_subject/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  console.log(request)
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify({ adminToken: JSON.parse(authToken).token, id: request })
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const DeleteSubjectApi = formData => {
  const url = BEBase + 'delete_subject/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      window.location.reload()
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const UpdateSubjectApi = formData => {
  const url = `${BEBase}update_subject/?_=${new Date().getTime()}` // Append a timestamp
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
      // Removed Content-Type; let the browser handle it automatically
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          console.log('Error details:', err)
          throw new Error('Network response was not ok')
        })
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const CreateFeesApi = formData => {
  const url = BEBase + 'create_fees/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}


export const CreateRevenuePerPlanApi = formData => {
  const url = BEBase + 'create_revenue_per_plan/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const CreateClientApi = formData => {
  const url = BEBase + 'create_client/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const ListFeesApi = (admin_id, isEmployee = false) => {
  const url = BEBase + 'list_fees/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify({ id: admin_id, isEmployee })
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const DeleteFeesApi = formData => {
  const url = BEBase + 'delete_fees/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      window.location.reload()
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const UpdateFeesApi = formData => {
  const url = `${BEBase}update_fees/?_=${new Date().getTime()}` // Append a timestamp
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token,
      'Content-Type': 'application/json'
      // Removed Content-Type; let the browser handle it automatically
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          console.log('Error details:', err)
          throw new Error('Network response was not ok')
        })
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const ListRevenuePerPlanApi = (admin_id, isEmployee = false) => {
  const url = BEBase + 'list_revenue_per_plan/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify({ id: admin_id, isEmployee })
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const DeleteRevenuePerPlanApi = formData => {
  const url = BEBase + 'delete_revenue_per_plan/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      window.location.reload()
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const UpdateRevenuePerPlanApi = formData => {
  const url = `${BEBase}update_revenue_per_plan/?_=${new Date().getTime()}` // Append a timestamp
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token,
      'Content-Type': 'application/json'
      // Removed Content-Type; let the browser handle it automatically
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          console.log('Error details:', err)
          throw new Error('Network response was not ok')
        })
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const CreateTransportApi = formData => {
  const url = BEBase + 'create_transport/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const ListTransportApi = request => {
  const url = BEBase + 'list_transport/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const DeleteTransportApi = formData => {
  const url = BEBase + 'delete_transport/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      window.location.reload()
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const UpdateTransportApi = formData => {
  const url = `${BEBase}update_transport/?_=${new Date().getTime()}` // Append a timestamp
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
      // Removed Content-Type; let the browser handle it automatically
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          console.log('Error details:', err)
          throw new Error('Network response was not ok')
        })
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const UpdateClientApi = formData => {
  const url = BEBase + 'update_client/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token,
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          console.log('Error details:', err)
          throw new Error('Network response was not ok')
        })
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const DeleteClientApi = formData => {
  const url = BEBase + 'delete_client/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      window.location.reload()
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}
export const ListTimeTableApi = request => {
  const url = BEBase + 'list_timeTable/'
  const encryptedCreds = localStorage.getItem('loginCred')

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage')
  }

  const decryptedCreds = decryptData(encryptedCreds)

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials')
  }

  const authToken = JSON.stringify(decryptedCreds)

  // Add var2 to the request object
  const extendedRequest = {
    ...request,
    "id": JSON.parse(authToken).token
  }
  console.log(extendedRequest)
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(extendedRequest)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json()
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error
    })
}



export const GetEmployeeDetail = request => {
  const url = BEBase + 'view_detail/'
  const encryptedCreds = localStorage.getItem('loginCred')

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage')
  }

  const decryptedCreds = decryptData(encryptedCreds)

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials')
  }

  const authToken = JSON.stringify(decryptedCreds)

  // Add var2 to the request object
  const extendedRequest = {
    ...request,
    // "id": JSON.parse(authToken).token
  }
  console.log(extendedRequest)
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(extendedRequest)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json()
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error
    })
}

export const ListClassRelatedToSectionApi = request => {
  const url = BEBase + 'class_related_to_section/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const ListSubjectFromClassNameApi = request => {
  const url = BEBase + 'list_subject_from_className/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const ListSubjectFromClassNameIdApi = request => {
  const url = BEBase + 'list_subject_from_className_id/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const UpdateTimeTableApi = formData => {
  const url = BEBase + 'update_timeTable/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token,
      'Content-Type': 'application/json'
      // Removed Content-Type; let the browser handle it automatically
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          console.log('Error details:', err)
          throw new Error('Network response was not ok')
        })
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const ClientAttendanceApi = formData => {
  const url = BEBase + 'client_attendance/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const ListClientAttendanceApi = request => {
  const url = BEBase + 'list_client_attendance/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const GetUserDetails = () => {
  const url = BEBase + 'get_user_details/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);


  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const EmployeeAttendanceApi = formData => {
  const url = BEBase + 'student_attendance/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const ListEmployeeAttendanceApi = request => {
  const url = BEBase + 'list_student_attendance/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const UpdateEmployeeApi = formData => {
  const url = BEBase + 'update_student/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token,
      // Removed Content-Type; let the browser handle it automatically
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          console.log('Error details:', err)
          throw new Error('Network response was not ok')
        })
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

// API Call Function for Updating Homework
export const UpdateEmployeeHomeworkApi = async formData => {
  const url = BEBase + 'update_student_homework/' // Your API endpoint
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: 'Token ' + JSON.parse(authToken).token
      },
      body: formData // Send the FormData object directly
    })

    if (!response.ok) {
      const errorData = await response.json()
      console.log('Error details:', errorData)

      // Check for permission denied error
      if (response.status === 403 &&
        errorData.error &&
        errorData.error.includes("Permission denied")) {
        // Force logout by removing credentials and reloading
        localStorage.removeItem('loginCred');
        window.location.href = '/';
        throw new Error(errorData.error);
      }

      throw new Error('Network response was not ok')
    }

    return response.json() // Return the parsed JSON response if successful
  } catch (error) {
    console.error('Error during the fetch operation:', error)
    throw error // Propagate the error for further handling
  }
}

export const DeleteEmployeeApi = formData => {
  const url = BEBase + 'delete_student/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      window.location.reload()
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const CreateEmployeeApi = formData => {
  const url = BEBase + 'create_student/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData
  })
    .then(async response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const responseData = await response.json(); // parse it here

      const permData = {
        employeeId: responseData.user.id, // now this will work
        product: "false",
        subject: "false",
        scrumBoard: "false",
        employeeTickets: "false",
        fees: "false",
        topImages: "false",
        client: "false",
        student: "false",
        studentAttendance: "false",
        accounts: "false",
        revenuePerPlan: "false",
        leaves: "false",
      };

      await create_or_update_user_permission(permData);
      return responseData;
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error);
      throw error;
    });

}

export const ListEmployeesApi = request => {
  const url = BEBase + 'list_student/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const ListEmployeesSectionApi = request => {
  const url = BEBase + 'list_student_section/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const ListEmployeesApiClient = request => {
  const url = BEBase + 'list_student_client/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const CreateEmployeeHomeworkApi = formData => {
  const url = BEBase + 'create_student_homework/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const ListEmployeesHourlyFees = request => {
  const url = BEBase + 'list_employee_hourly_fees/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const GetTicketDataByCode = request => {
  const url = BEBase + 'get_single_ticket/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const GetTicketNotifications = request => {
  const url = BEBase + 'get_ticket_notifications/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const GetTicketHistory = request => {
  const url = BEBase + 'get_ticket_history/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const MarkNotificationAsRead = request => {
  const url = BEBase + 'mark_notification_as_read/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}


export const create_ticket_comment = request => {
  const url = BEBase + 'create_ticket_comment/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: request
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const CreateEmployeeHourlyFeesApi = formData => {
  const url = BEBase + 'create_employee_hourly_fees/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(formData)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const ListEmployeeHomeworkApi = request => {
  const url = BEBase + 'list_student_homework/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const ListClientTimetableApi = async request => {
  const url = BEBase + 'list_client_timeTable/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + JSON.parse(authToken).token
      },
      body: JSON.stringify(request)
    })

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }

    const data = await response.text() // Use text() to log raw response
    console.log('Raw API Response:', data)

    const jsonData = JSON.parse(data) // Explicitly parse JSON
    return jsonData
  } catch (error) {
    console.error('API Fetch Error:', error)
    throw error
  }
}

export const ListSectionFromIdApi = request => {
  const url = BEBase + 'list_section_from_id/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const ListClassFromIdApi = request => {
  const url = BEBase + 'list_class_from_id/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const ListSubjectFromIdApi = request => {
  const url = BEBase + 'list_subject_from_id/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const DeleteEmployeeHomeworkApi = async formData => {
  const url = BEBase + 'delete_student_homework/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: 'Token ' + JSON.parse(authToken).token
      },
      body: formData // Directly use the FormData object
    });
    if (!response.ok) {
      const errorData = await response.json();
      console.log('Error details:', errorData);

      // Check for permission denied error
      if (response.status === 403 &&
        errorData.error &&
        errorData.error.includes("Permission denied")) {
        // Force logout by removing credentials and reloading
        localStorage.removeItem('loginCred');
        window.location.href = '/';
        throw new Error(errorData.error);
      }

      throw new Error('Network response was not ok');
    }
    // window.location.reload();
  } catch (error) {
    console.log('There was a problem with the fetch operation:', error);
    throw error; // Rethrow the error for further handling
  }
}

export const CreateNoticeApi = formData => {
  const url = BEBase + 'create_notice/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const ListNoticeApi = request => {
  const url = BEBase + 'list_notice/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const UpdateNoticeApi = formData => {
  const url = BEBase + 'update_notice/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const DeleteNoticeApi = formData => {
  const url = BEBase + 'delete_notice/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

// Upload image API
export const UploadImageApi = formData => {
  const url = BEBase + 'upload_image/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const ListImagesApi = request => {
  const url = BEBase + 'list_images/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

// Delete image API
export const DeleteImageApi = formData => {
  const url = BEBase + 'delete_image/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const ListVideoApi = request => {
  const url = BEBase + 'list_video/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

// export const for video-related API calls

export const CreateVideoApi = request => {
  const url = BEBase + 'add_video/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const DeleteVideoApi = formData => {
  const url = BEBase + 'delete_video/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const UpdateVideoApi = formData => {
  const url = BEBase + 'update_video/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token,
      'Content-Type': 'application/json'
      // Removed Content-Type; let the browser handle it automatically
    },
    body: JSON.stringify(formData) // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          console.log('Error details:', err)
          throw new Error('Network response was not ok')
        })
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const CreateExamApi = request => {
  const url = BEBase + 'create_exam/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const ListExamApi = request => {
  const url = BEBase + 'list_exam/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const GetEmployeeResultApi = request => {
  const url = BEBase + 'view_result/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const UpdateExamApi = request => {
  const url = BEBase + 'update_exam/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      //console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const DeleteExamApi = request => {
  const url = BEBase + 'delete_exam/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      window.location.reload() // Return the parsed JSON response
    })
    .catch(error => {
      //console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const ListCreateResultApi = request => {
  const url = BEBase + 'list_createResult/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const CreateCreateResultApi = request => {
  const url = BEBase + 'create_createResult/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const UpdateAddMarksApi = formData => {
  const url = BEBase + 'update_addMarks/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const ListAddMarksApi = request => {
  const url = BEBase + 'list_addMarks/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const UpdateCreateResultApi = request => {
  const url = BEBase + 'list_updateResult/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const DeleteCreateResultApi = formData => {
  const url = BEBase + 'delete_createResult/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      window.location.reload()
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const UpdatePublishResultApi = formData => {
  const url = BEBase + 'update_publishResult/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      //window.location.reload()
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const CreateTopImageApi = formData => {
  const url = BEBase + 'create_top_image/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      //window.location.reload()
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const ListTopImageApi = formData => {
  const url = BEBase + 'list_top_image/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  // Log the request payload
  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token // Only send authorization header
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Assuming the server sends a JSON response
    })
    .then(data => {
      // Process the JSON response here (e.g., log or return it)
      console.log('Response data:', data)
      return data
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const DeleteTopImageApi = formData => {
  const url = BEBase + 'delete_top_image/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      window.location.reload()
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const FetchDataFromOtpApi = request => {
  const url = BEBase + 'fetch_data_from_otp/'

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Invalid Login Credentials')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('Invalid Login Credentials', error)
      throw error // Rethrow the error for further handling
    })
}

export const CreateExpenseApi = formData => {
  const url = BEBase + 'create_expense/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const ListExpenseApi = (admin_id, isEmployee = false) => {
  const url = BEBase + 'list_expense/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify({ id: admin_id, isEmployee })
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const ListJobsApi = formData => {
  const url = BEBase + 'jenkins_jobs/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(formData)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}


export const TriggerJenkinsApi = formData => {
  const url = BEBase + 'trigger_jenkins_build/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(formData)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const GetBuildStatusApi = formData => {
  const url = BEBase + 'build_status/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(formData)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}


export const UpdateExpenseApi = formData => {
  const url = `${BEBase}update_expense/?_=${new Date().getTime()}` // Append a timestamp
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token,
      'Content-Type': 'application/json'
      // Removed Content-Type; let the browser handle it automatically
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          console.log('Error details:', err)
          throw new Error('Network response was not ok')
        })
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const DeleteExpenseApi = formData => {
  const url = BEBase + 'delete_expense/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      window.location.reload()
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

// Scrum Board API functions
export const getScrumBoardData = () => {
  const url = BEBase + 'get_scrum_board/1/'; // Default to board ID 1
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    }
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error);
      throw error;
    });
};

export const updateTicketPosition = request => {
  const url = BEBase + 'update_ticket_position/';
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error);
      throw error;
    });
};

export const addTicketToScrumBoard = request => {
  const url = BEBase + 'add_ticket_to_scrum/';
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  // Add adminToken to the request
  const requestWithToken = {
    ...request,
    adminToken: JSON.parse(authToken).admin?.adminToken || '',
    scrumId: 1 // Default to board ID 1
  };

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(requestWithToken)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error);
      throw error;
    });
};

// Add new API endpoints for SCRUM boards
export const create_scrum = formData => {
  const url = BEBase + 'create_scrum/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(formData)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json()
    })
    .catch(error => {
      console.error('Error creating SCRUM board:', error)
      throw error
    })
}


export const delete_scrum = scrumId => {
  const url = BEBase + `delete_scrum/${scrumId}/`;
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  return fetch(url, {
    method: 'DELETE',
    headers: {
      'Authorization': 'Token ' + JSON.parse(authToken).token
    }
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response;
    })
    .catch(error => {
      console.error('Error deleting SCRUM board:', error);
      throw error;
    });
};



export const update_scrum = formData => {
  const url = BEBase + `update_scrum/${formData.id}/`
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(formData)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json()
    })
    .catch(error => {
      console.error('Error creating SCRUM board:', error)
      throw error
    })
}

export const list_scrums = () => {
  const url = BEBase + 'list_scrums/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    }
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json()
    })
    .catch(error => {
      console.error('Error listing SCRUM boards:', error)
      throw error
    })
}

export const get_scrum_board_by_id = scrumId => {
  const url = BEBase + `get_scrum_board/${scrumId}/`
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    }
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json()
    })
    .catch(error => {
      console.error(`Error fetching SCRUM board ${scrumId}:`, error)
      throw error
    })
}

export const list_filtered_tickets = async (params) => {
  const url = BEBase + 'list_filtered_tickets/';
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + JSON.parse(authToken).token
      },
      body: JSON.stringify(params)
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('API Error:', errorData);
      throw new Error('Failed to fetch tickets');
    }

    return response.json();
  } catch (error) {
    console.error('Error fetching filtered tickets:', error);
    throw error;
  }
};


export const get_ticket_counts = async (params) => {
  const url = BEBase + 'get_ticket_counts/';
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + JSON.parse(authToken).token
      },
      body: JSON.stringify(params)
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('API Error:', errorData);
      throw new Error('Failed to fetch ticket counts');
    }

    return response.json();
  } catch (error) {
    console.error('Error fetching ticket counts:', error);
    throw error;
  }
};

export const create_leaves = async (params) => {
  const url = BEBase + 'create_leaves/';
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + JSON.parse(authToken).token
      },
      body: JSON.stringify(params)
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('API Error:', errorData);
      throw new Error('Failed to fetch ticket counts');
    }

    return response.json();
  } catch (error) {
    console.error('Error fetching ticket counts:', error);
    throw error;
  }
};

export const list_leaves = request => {
  const url = BEBase + 'list_leaves/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const delete_leaves = formData => {
  const url = BEBase + 'delete_leaves/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      window.location.reload()
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const update_leaves = formData => {
  const url = `${BEBase}update_leaves/?_=${new Date().getTime()}` // Append a timestamp
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token,
      'Content-Type': 'application/json'
      // Removed Content-Type; let the browser handle it automatically
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          console.log('Error details:', err)
          throw new Error('Network response was not ok')
        })
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const list_employeeType_from_id = request => {
  const url = BEBase + 'list_employeeType_from_id/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const list_leaves_from_employee_type = request => {
  const url = BEBase + 'list_leaves_from_employee_type/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const list_leaves_per_employee = request => {
  const url = BEBase + 'list_leaves_per_employee/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const list_leaves_of_all_employees = request => {
  const url = BEBase + 'list_leaves_of_all_employees/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const create_leaves_per_employee = async (params) => {
  const url = BEBase + 'create_leaves_per_employee/';
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + JSON.parse(authToken).token
      },
      body: JSON.stringify(params)
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('API Error:', errorData);
      throw new Error('Failed to fetch ticket counts');
    }

    return response.json();
  } catch (error) {
    console.error('Error fetching ticket counts:', error);
    throw error;
  }
};

export const update_leave_status = formData => {
  const url = `${BEBase}update_leave_status/?_=${new Date().getTime()}` // Append a timestamp
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token,
      'Content-Type': 'application/json'
      // Removed Content-Type; let the browser handle it automatically
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          console.log('Error details:', err)
          throw new Error('Network response was not ok')
        })
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const create_leave_update_history = async (params) => {
  const url = BEBase + 'create_leave_update_history/';
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + JSON.parse(authToken).token
      },
      body: JSON.stringify(params)
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('API Error:', errorData);
      throw new Error('Failed to fetch ticket counts');
    }

    return response.json();
  } catch (error) {
    console.error('Error fetching ticket counts:', error);
    throw error;
  }
}

export const list_leave_update_history = request => {
  const url = BEBase + 'list_leave_update_history/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const delete_account = async (formData) => {
  const url = BEBase + 'delete_account/';
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData);

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(async (response) => {
      if (!response.ok) {
        const errorResponse = await response.json(); // Await JSON parsing
        throw new Error(errorResponse?.message || JSON.stringify(errorResponse) || 'Unknown error occurred');
      }
      window.location.reload();
      return response; // ✅ This is now reachable
    })
    .catch((error) => {
      console.log('There was a problem with the fetch operation:', error);
      throw error; // ✅ This rethrows the error properly
    });
};


export const create_docs_page = async (params) => {
  const url = BEBase + 'create_docs/';
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + JSON.parse(authToken).token
      },
      body: JSON.stringify(params)
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('API Error:', errorData);
      throw new Error('Failed to create docs page');
    }

    return response.json();
  } catch (error) {
    console.error('Error creating docs page:', error);
    throw error;
  }
};

export const list_public_docs_page = async (public_uuid) => {
  const url = BEBase + `get_docs/${public_uuid}/`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('API Error:', errorData);
      throw new Error('Failed to fetch public docs page');
    }

    return response.json();
  } catch (error) {
    console.error('Error fetching public docs page:', error);
    throw error;
  }
};

export const UpdateDocsApi = formData => {
  const url = BEBase + 'update_docs/';
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData);

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData) // assuming formData is a JS object, not FormData()
  })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          console.log('Error details:', err);
          throw new Error('Network response was not ok');
        });
      }
      return response.json(); // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error);
      throw error;
    });
};

export const list_my_docs_pages = (formData) => {
  /*const url = BEBase + "my_docs/";
  const encryptedCreds = localStorage.getItem("loginCred");

  if (!encryptedCreds) throw new Error("No login credentials found");
  const decryptedCreds = decryptData(encryptedCreds);
  const token = decryptedCreds?.token;

  if (!token) throw new Error("No valid token");

  return fetch(url, {
    method: "POST",
    headers: {
       Authorization: 'Token ' + JSON.parse(authToken).token,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  }).then((res) => {
    if (!res.ok) throw new Error("Failed to fetch documents");
    return res.json();
  });*/
  const url = BEBase + 'my_docs/';
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify({ token: JSON.parse(authToken).token, userDetails: JSON.parse(authToken).user })
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
};

export const delete_my_doc = (public_uuid) => {
  const url = BEBase + 'delete_docs/';
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = decryptedCreds.token;

  const formData = new FormData();
  formData.append('public_uuid', public_uuid);

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + authToken,
    },
    body: formData,
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json(); // or .text() depending on your backend
    })
    .catch(error => {
      console.error('Error while deleting document:', error);
      throw error;
    });
};


export const CanUserAccessDoc = async (payload) => {
  return await fetch(BEBase + "check_docs_access", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  }).then((res) => res.json());
};

export const save_draft_api = async (params) => {
  const url = BEBase + 'save_draft_view'; // matches re_path
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = decryptedCreds.token;

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + authToken,
      },
      body: JSON.stringify(params),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Draft Save Error:', errorData);
      throw new Error('Failed to save draft');
    }

    return response.json(); // will contain { id, title, content, ... }
  } catch (error) {
    console.error('Error saving draft:', error);
    throw error;
  }
};

export const delete_draft_api = (draft_id) => {
  const url = BEBase + 'delete_draft_view/';
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = decryptedCreds.token;

  const formData = new FormData();
  formData.append('draft_id', draft_id.draft_id);

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + authToken,
    },
    body: formData,
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json(); // or .text() depending on your backend
    })
    .catch(error => {
      console.error('Error while deleting draft:', error);
      throw error;
    });
};

export const get_user_drafts_api = (request) => {
  const url = BEBase + 'get_user_drafts_api/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify({ id: request })
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
};

export const create_or_update_user_permission = request => {
  const url = BEBase + 'create_or_update_user_permission/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(async response => {
      const data = await response.json()

      if (!response.ok) {
        // Throw the API's error message from JSON
        throw new Error(JSON.stringify(data))
      }

      return data // If successful, return parsed data
    })
    .catch(error => {
      console.error('Fetch error:', error)
      throw error // Allow caller to handle it
    })
}

export const get_user_permission_by_employee = request => {
  const url = BEBase + 'get_user_permission_by_employee/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const employee_bandwidth = request => {
  const url = BEBase + 'employee_bandwidth/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(request)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const create_email_group = formData => {
  const url = BEBase + 'create_email_group/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const list_email_group = formData => {
  const url = BEBase + 'list_email_group/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const delete_email_group = formData => {
  const url = BEBase + 'delete_email_group/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(formData) // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      window.location.reload()
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const update_email_group = formData => {
  const url = `${BEBase}update_email_group/?_=${new Date().getTime()}` // Append a timestamp
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token,
      'Content-Type': 'application/json'
      // Removed Content-Type; let the browser handle it automatically
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          console.log('Error details:', err)
          throw new Error('Network response was not ok')
        })
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const add_email_contact = formData => {
  const url = `${BEBase}add_email_contact/?_=${new Date().getTime()}` // Append a timestamp
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token,
      'Content-Type': 'application/json'
      // Removed Content-Type; let the browser handle it automatically
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          console.log('Error details:', err)
          throw new Error('Network response was not ok')
        })
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const list_email_contact = formData => {
  const url = BEBase + 'list_email_contact/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const bulk_upload_contacts = formData => {
  const url = BEBase + 'bulk_upload_contacts/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const update_email_contact = formData => {
  const url = `${BEBase}update_email_contact/?_=${new Date().getTime()}` // Append a timestamp
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token,
      'Content-Type': 'application/json'
      // Removed Content-Type; let the browser handle it automatically
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          console.log('Error details:', err)
          throw new Error('Network response was not ok')
        })
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const delete_email_contact = formData => {
  const url = BEBase + 'delete_email_contact/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(formData) // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      window.location.reload()
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const send_mass_email = formData => {
  const url = `${BEBase}send_mass_email/?_=${new Date().getTime()}` // Append a timestamp
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token,
      'Content-Type': 'application/json'
      // Removed Content-Type; let the browser handle it automatically
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          console.log('Error details:', err)
          throw new Error('Network response was not ok')
        })
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const list_bounced_mails = formData => {
  const url = BEBase + 'list_bounced_mails/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const get_ticket_comment = request => {
  const url = BEBase + 'get_ticket_comment/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: request
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const update_ticket_comment = formData => {
  const url = BEBase + 'update_ticket_comment/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token,
      'Content-Type': 'application/json'
      // Removed Content-Type; let the browser handle it automatically
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const delete_ticket_comment = formData => {
  const url = BEBase + 'delete_ticket_comment/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: JSON.stringify(formData) // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      window.location.reload()
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const toggle_discovery_status = formData => {
  const url = BEBase + 'toggle_discovery_status/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Token ' + JSON.parse(authToken).token,
      'Content-Type': 'application/json'
      // Removed Content-Type; let the browser handle it automatically
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const list_user_discovery = formData => {
  const url = BEBase + 'list_user_discovery/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const FdListApi = formData => {
  const url = BEBase + 'FdListApi/'
  const encryptedCreds = localStorage.getItem('loginCred');

  if (!encryptedCreds) {
    throw new Error('No login credentials found in localStorage');
  }

  const decryptedCreds = decryptData(encryptedCreds);

  if (!decryptedCreds || !decryptedCreds.token) {
    throw new Error('Failed to retrieve valid token from decrypted credentials');
  }

  const authToken = JSON.stringify(decryptedCreds);

  console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}

export const ChatBotApi = formData => {
  const url = BEBase + 'chatbot/'
  // const encryptedCreds = localStorage.getItem('loginCred');

  // if (!encryptedCreds) {
  //   throw new Error('No login credentials found in localStorage');
  // }

  // const decryptedCreds = decryptData(encryptedCreds);

  // if (!decryptedCreds || !decryptedCreds.token) {
  //   throw new Error('Failed to retrieve valid token from decrypted credentials');
  // }

  // const authToken = JSON.stringify(decryptedCreds);

  // console.log('Request payload:', formData)

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      // Authorization: 'Token ' + JSON.parse(authToken).token
    },
    body: formData // Directly use the FormData object
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json() // Return the parsed JSON response
    })
    .catch(error => {
      console.log('There was a problem with the fetch operation:', error)
      throw error // Rethrow the error for further handling
    })
}